import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      q: 'Как проходит тренинг по продажам через переписку?',
      a: 'Тренинг начинается с диагностики: изучаем реальные переписки команды в Telegram, WhatsApp, CRM, e-mail. Затем разрабатываем адаптированную программу. Сам тренинг на 80% состоит из практики: разбираем конкретные диалоги участников, отрабатываем скрипты, учимся управлять перепиской. После — сопровождение и разбор новых диалогов.',
    },
    {
      q: 'Можно ли обучить переписке опытных менеджеров?',
      a: 'Да. Опытные менеджеры часто имеют устоявшиеся привычки из телефонных продаж, которые не работают в переписке. Мы показываем разницу между телефонной и текстовой коммуникацией, даём инструменты адаптации. Опытные сотрудники быстрее внедряют новые техники, потому что у них уже есть база продаж.',
    },
    {
      q: 'Работаете ли вы с Telegram?',
      a: 'Да, Telegram — один из основных каналов в программе. Разбираем специфику: неформальный тон, скорость ответа, использование голосовых сообщений, работу с группами и каналами. Учим выстраивать доверие в мессенджере и доводить диалог до сделки.',
    },
    {
      q: 'Обучаете ли работе с WhatsApp?',
      a: 'Да, WhatsApp — ключевой канал программы. Разбираем особенности: неформальный стиль, работу с медиафайлами, голосовые сообщения, групповые чаты. Учим выстраивать продающий диалог без давления и шаблонов.',
    },
    {
      q: 'Можно ли разобрать реальные переписки нашей компании?',
      a: 'Это основа методологии. До тренинга запрашиваем доступ к перепискам и анализируем их. Во время обучения участники разбирают именно свои диалоги — с конкретными клиентами, возражениями и ошибками. Это в десятки раз эффективнее абстрактных примеров.',
    },
    {
      q: 'Работаете ли с CRM-системами (Bitrix24, AmoCRM)?',
      a: 'Да. Обучаем работе в чатах Bitrix24, AmoCRM и других CRM. Разбираем, как вести клиента внутри системы, не терять историю переписки, правильно фиксировать договорённости и управлять воронкой через переписку.',
    },
    {
      q: 'Есть ли сопровождение после тренинга?',
      a: 'Да, посттренинговое сопровождение — обязательный элемент. Мы продолжаем разбирать переписки участников, даём обратную связь, поддерживаем в чате. Без сопровождения эффективность тренинга падает на 70–80% уже через месяц.',
    },
    {
      q: 'Как быстро появляются первые результаты?',
      a: 'Первые изменения видны уже во время тренинга — участники видят свои ошибки и сразу применяют новые техники. Устойчивые результаты появляются через 2–4 недели практики с сопровождением. Измеримые бизнес-показатели (конверсия, средний чек) — через 1–3 месяца.',
    },
    {
      q: 'Можно ли обучить удалённую команду онлайн?',
      a: 'Да, онлайн-формат полностью адаптирован для удалённых команд. Живые сессии через видеосвязь, разбор переписок через демонстрацию экрана, работа в группах. Онлайн-тренинг по переписке даже органичнее очного — мы работаем в цифровой среде.',
    },
    {
      q: 'Подходит ли обучение для B2B?',
      a: 'Да. В B2B переписка играет ключевую роль: КП, коммерческие предложения, согласования, работа с закупщиками — всё через текст. Обучаем вести сложные B2B-диалоги: аргументировать ценность, работать с ЛПР, сопровождать длинный цикл сделки.',
    },
    {
      q: 'Подходит ли обучение для B2C?',
      a: 'Да. В B2C переписка стала основным каналом: Instagram Direct, WhatsApp, чаты сайта, Telegram. Обучаем быстро обрабатывать обращения, вести клиента к покупке в чате, работать с возражениями и повышать средний чек через переписку.',
    },
    {
      q: 'Можно ли адаптировать программу под нашу компанию?',
      a: 'Каждая программа создаётся индивидуально. Мы изучаем ваш продукт, цикл сделки, каналы коммуникации, уровень команды. Адаптируем кейсы, скрипты и упражнения под реальные диалоги ваших менеджеров. Никаких шаблонных программ.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-question-answer-line"></i>
            FAQ
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на самые частые вопросы о тренинге по продажам через переписку.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full text-left px-5 md:px-6 py-4 flex items-center justify-between gap-4 cursor-pointer group hover:bg-teal-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-gray-900">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === i ? 'bg-teal-600 text-white' : 'bg-gray-200 text-gray-500 group-hover:bg-teal-100 group-hover:text-teal-600'}`}>
                  <i className={`text-sm transition-transform ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-out overflow-hidden ${openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-5 md:px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}